import React from "react";
import { Card, CardContent, Typography, Box, LinearProgress } from "@mui/material";
import { nFormatter } from "../../../Helpers";
import DashboardCardInfo from "../../../Components/common/DashboardCardInfo";

const SalesCard = ({
  title,
  saleAmount,
  targetAmount,
  tooltipTitle,
  isAnnualSale=false
}) => {
const normalizeNumber = (val) => {
  if (val == null || val === "") return 0;
  if (typeof val === "number") return val;
  if (/^\d+,\d+$/.test(val)) {
    return parseFloat(val.replace(",", "."));
  }
  return parseFloat(val.replace(/,/g, ""));
};

const sale = normalizeNumber(saleAmount);
const target = normalizeNumber(targetAmount);

const percentAchieved = (() => {
    if (!target || target === 0) return 100;
    const percent = Math.abs(((sale / target) * 100)?.toFixed(1));
    return isFinite(percent) ? percent : 100;
  })();
  return (
    <Card
      elevation={0}
      sx={{ borderRadius: 2, padding: 0, backgroundColor: "transparent" }}
    >
      <CardContent
        sx={{
          px: 1,
          borderBottom: "0.5px solid lightGray",
          "&:last-child": { pb: 1 },
        }}
      >
        {/* Top row */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {/* Left */}
          <Box>
            <Typography variant="body2" color="text.secondary">
              {title}
            </Typography>
            <Typography variant="h6" title={saleAmount?.toLocaleString()}>
              {nFormatter(saleAmount,2)} SAR
            </Typography>
          </Box>

          {/* Right */}
          <Box textAlign="right">
            <Typography variant="h6" color="success.main">
              {percentAchieved}%
            </Typography>
            {/* <Typography variant="caption" color="text.secondary">
              Achieved
            </Typography> */}
          </Box>
        </Box>

        {/* Progress Bar */}
        <Box mt={1}>
          <LinearProgress
            variant="determinate"
            value={percentAchieved}
            sx={{
              height: 8,
              borderRadius: 5,
              "& .MuiLinearProgress-bar": { backgroundColor: "success.main" },
            }}
          />
        </Box>
        <Box sx={{ mt: 1.7, position: "relative" }}>
          <Typography variant="body2" color="text.secondary" title={targetAmount.toLocaleString()}>
            <strong>Target</strong> {nFormatter(targetAmount,2)} SAR
          </Typography>
          <DashboardCardInfo title={tooltipTitle} bottom={0} right={0}/>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SalesCard;
